<template>
  <button @click="openSlideoutCart">
    <slot />
  </button>
</template>

<script>
import { useCartStore } from '../pinia/CartStore'
import { mapActions } from 'pinia'

export default {
  methods: {
    ...mapActions(useCartStore, ['openSlideoutCart'])
  },
}
</script>
